import axios from 'axios';

export default {
    namespaced: true,

    state: {
        all: [],
        byId: {},
    },

    actions: {
        index({commit}) {
            return axios.get(process.env.VUE_APP_API_URL + 'pumps')
                .then(({data}) => {
                    commit('setPumps', data);
                });
        },
    },

    getters: {
        getAll(state) {
            return state.all;
        },

        getPumps(state, getters, rootState, rootGetters) {
            return state.all
                .filter(pump => {
                    return pump[rootGetters['preference/getMotorOption']] === true;
                })
                .sort((a, b) => {
                    return a.cc - b.cc;
                });
        },

        getAvailablePumps(state, getters, rootState, rootGetters) {
            let pumps = getters['getPumps'];
            let motor = rootGetters["build/getMotor"];

            if (motor.workplace === true || motor.and_pump === true || motor.industrial === true) {
                let flangeSize = motor.flange_size;
                let lanternPieces = rootGetters['lanternPieces/getLanternPiecesByFlangeSize'](flangeSize);

                let pumpGroupIds = [];
                lanternPieces.forEach(lanternPiece => {
                    pumpGroupIds.push(lanternPiece.pump_group_id);
                });

                return pumps.filter((pump) => {
                    return pumpGroupIds.includes(pump.pump_group_id)
                });
            }

            return pumps;
        },

        names: (state) => {
            //todo set the name in backend
            return state.all.map((t) => {
                return {
                    id: t.id,
                    name: (t.cc + ' cc pomp'),
                }
            });
        },

        getPumpRender: (state, getters) => (pump, flangeSize) => {
            return pump.renders.find(render => {
                return render.flange_size === flangeSize;
            })
        },
    },
    mutations: {
        setPumps(state, pumps) {
            let byId = {};
            pumps.forEach((p) => {
                //todo set the name in backend
                let pump = {...p, name: (p.cc + 'cc pomp')}
                byId[p.id] = pump;
            });
            state.all = pumps;
            state.byId = byId;
        },
    },
};
